import type { ActionFunctionArgs, HeadersFunction, LoaderFunction, MetaFunction } from '@remix-run/node';
import { redirect } from '@remix-run/node';
import type { ShouldRevalidateFunction } from '@remix-run/react';

import TipJarReader from '~/components/TipJarReader/TipJarReader';
import getTipJar from '~/services/api/tip_jar/getTipJar.server';
import { tipJarMeta } from '~/services/tipJarMeta';
import { tipJarPageAction, tipJarPageResponse } from '~/services/tipJarPage.server';
import { loaderSession } from '~/session';
import { BASE_CACHE_TAG } from '~/utils/setCacheHeaders/index.server';
import { shouldRevalidateLoaderData } from '~/utils/shouldRevalidateLoaderData';

export const headers: HeadersFunction = ({ loaderHeaders }) => {
  return {
    'cache-control': loaderHeaders.get('cache-control') || 'max-age=0',
    'Cache-Tag': loaderHeaders.get('Cache-Tag') || BASE_CACHE_TAG,
  };
};

export const meta: MetaFunction = tipJarMeta;

export const loader: LoaderFunction = async ({ request, context }) => {
  const url = new URL(request.url);
  if (url.pathname.endsWith('/')) {
    url.pathname = url.pathname.slice(0, -1);
    return redirect(`${url.pathname}${url.search}`, 301);
  }

  const { session } = await loaderSession(request);
  const [site, tipJar] = await Promise.all([context.getSite(request, session), getTipJar(request, session)]);

  return tipJarPageResponse({ request, site, tipJar });
};

export const action = ({ request }: ActionFunctionArgs) => tipJarPageAction(request);

// A checkout post must not reload the meter, which would count the tip a second time.
export const shouldRevalidate: ShouldRevalidateFunction = (args) => {
  if (args.formMethod === 'POST' && args.formData?.has('amount_cents') === true) return false;

  return shouldRevalidateLoaderData(args);
};

const Contributions = () => <TipJarReader />;

export default Contributions;
